import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface ITenantReturnsSettings {
  tenantId: string;
  trustScoreWindowDays: number;
  trustScoreRecomputeCron: string;
  trustExcellentThreshold: number;
  trustGoodThreshold: number;
  trustModerateThreshold: number;
  trustAtRiskThreshold: number;
  highValueThresholdAmount: number;
  preventionReturnRateThresholdPercent: number;
  preventionMinSoldQuantity: number;
  preventionWindowDays: number;
  preventionRecomputeCron: string;
  preventionSpikeMultiplier: number;
  alertDefaultChannels: string[];
  alertEmailRecipients: string[];
  alertSlackWebhook: string | null;
  defaultRefundMethod: string;
  autoApproveThresholdAmount: number | null;
  couponValidityDays: number;
  disputeCountMax: number;
  ebarimtReturnReceiptEnabled: boolean;
  // Refund SLA per channel (days); CREDIT_BALANCE is instant → no field
  refundSlaBankTransferDays: number;
  refundSlaInvoiceDeductionDays: number;
  refundSlaCashDays: number;
  // Data retention (days)
  retentionHotDays: number;
  retentionArchiveAfterDays: number;
  retentionErasureSlaDays: number;
  // Per-reason sub-reason taxonomy: { [returnReason]: string[] }
  subReasonTaxonomy: Record<string, string[]>;
  // ── General policy toggles (§9.6.1) ──
  replacementShipFirstEnabled: boolean;          // D14
  invoiceDeductionFallbackEnabled: boolean;      // D17
  invoiceDeductionFallbackChannel: string;       // D17
  staleRequestedAutoCancelEnabled: boolean;      // D20
  staleRequestedAutoCancelDays: number;          // D20
  // ── Refund SLA / lifecycle policy (§9.6.2) ──
  refundSlaBankTransferMinDays: number;          // BANK range MIN (refundSlaBankTransferDays = MAX)
  financeConfirmationSlaDays: number;            // C4
  financeConfirmationEscalationEnabled: boolean; // C4
  pickupSlaSellerDays: number;                   // D11
  pickupSlaBuyerDays: number;                    // D11
  pickupSlaBreachEventEnabled: boolean;
  warehouseReceiptSlaDays: number;               // D10 R-106
  warehouseReceiptBreachEventEnabled: boolean;
  transitExceptionSlaDays: number;               // D13
  transitExceptionAutoResolveFallback: string;   // D13
  escalationCron: string;
}

export const get = () =>
  httpRequest.get("/ord/tenant-returns-settings") as Promise<ITenantReturnsSettings>;

export const update = (patch: Partial<ITenantReturnsSettings>) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.put("/ord/tenant-returns-settings", patch as any);
